<div class="dialog-content" fxLayout="row" fxLayoutGap="0px" fxLayoutAlign="start center">
    <mat-icon id="dialog-icon" color="primary">warning</mat-icon>
    <div>
        <h2 mat-dialog-title i18n>Delete Item?</h2>
        <mat-dialog-content fxLayout="column" fxLayoutGap="10px">
            <p i18n>Name: <strong>{{data.name}}</strong></p>
            <p i18n>Are you sure you want to delete the item?</p>
        </mat-dialog-content>
    </div>
</div>

<!-- <h1 mat-dialog-title i18n>Delete Item?</h1>
<mat-dialog-content fxLayout="column" fxLayoutGap="10px">
    <p>Name: <strong>{{data.name}}</strong></p>
    <p>Are you sure you want to delete the item?</p>
</mat-dialog-content> -->

<mat-dialog-actions align="end">
    <button mat-button (click)="abort()">Abort</button>
    <button mat-button (click)="save()" cdkFocusInitial>Ok</button>
</mat-dialog-actions>
